/** Core Content Purpose adMeta: coreContentPurpose, documentMeta: contentCommerceFormat */
// export enum CoreContentPurpose {
//   advertorial = 'advertorial',
//   affiliate = 'affiliate',
//   affiliateBuyingAdvice = 'affiliate-buying-advice',
//   affiliateBuyingGuides = 'affiliate-buying-guides',
//   affiliateDeals = 'affiliate-deals',
//   affiliateOther = 'affiliate-other',
//   affiliateReviews = 'affiliate-reviews',
//   affiliateTrending = 'affiliate-trending',
//   brandContent = 'brand_content',
//   brandedAffiliate = 'branded_affiliate',
//   intent = 'intent',
//   membership = 'membership',
//   promotionalMarketing = 'promotional_marketing',
//   reach = 'reach'
// }

export enum ContentCommerceFormat {
  affiliateBuyingAdvice = 'affiliate-buying-advice',
  affiliateBuyingGuides = 'affiliate-buying-guides',
  affiliateReviews = 'affiliate-reviews',
  affiliateTrending = 'affiliate-trending',
  affiliateDeals = 'affiliate-deals',
  affiliateOther = 'affiliate-other',
  brandedAffiliate = 'branded_affiliate'
}

/** article series type */
export enum SeriesType {
  browse = 'browse',
  slide = 'slide'
}

export enum CtaBoxIcon {
  download = 'download',
  newsletter = 'newsletter',
  noIcon = 'noIcon'
}
